import { render, staticRenderFns } from "./LogosectionBlock.vue?vue&type=template&id=631d37b9&scoped=true"
import script from "./LogosectionBlock.vue?vue&type=script&lang=js"
export * from "./LogosectionBlock.vue?vue&type=script&lang=js"
import style0 from "./LogosectionBlock.vue?vue&type=style&index=0&id=631d37b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631d37b9",
  null
  
)

export default component.exports